import { api } from "@/api";
import { sleep } from "@/shared/utils";

export interface DepositoAssignResponse {
    id: string,
    nombre: string,
    principal: boolean,
    token: string
}

export async function assignDeposito(depositoId: string): Promise<DepositoAssignResponse> {
    await sleep(1000);
    const response = await api.post("deposito_actual/assign/" + depositoId);
    return response.data;
}
